import type { EchographyAdditionalQuestionRequestData } from '@common/validation/customControls/echography/echographyAdditionalQuestionRequest';
import { CustomControlCode } from '@common/enums';
import { useProcessActivityReadContext } from '@frontend/utils';
import { AdditionalQuestionRead } from '../../additionalQuestionAndAnswer/AdditionalQuestionRead';

export function EchographyAdditionalQuestionRequestRead() {
    const { processActivity } = useProcessActivityReadContext<EchographyAdditionalQuestionRequestData>();

    return (
        <AdditionalQuestionRead
            customControlCode={CustomControlCode.EchographyAdditionalQuestionRequest}
            message={processActivity.customControlData.bericht}
        />
    );
}
